import React, { FunctionComponent, ReactNode } from 'react';
import classnames from 'classnames';
import MetsIcon from '../MetsIcon';

interface MetsMessagesPropTypes {
    containerClassName?: string;
    className?: string;
    /** The prefix used to generated an ID for different elements. If this is null, a default will be generated. */
    idPrefix?: string;
    severity?: MetsMessagesSeverityEnum;
    messageTitle?: ReactNode;
}

export enum MetsMessagesSeverityEnum {
    Error = 'Error',
    Success = 'Success',
    Warning = 'Warning',
    Info = 'Info',
}

/**
 * Generic Messages component that renders a message block and styles differently based on severity. Based off of the mets component called Messages.
 * 
 * @param {object} props 
 */
const MetsMessages: FunctionComponent<MetsMessagesPropTypes> = ({containerClassName, className, severity = MetsMessagesSeverityEnum.Error, messageTitle, children}) => {


    return (
        
        <div className={classnames("message-panel-container", severity.toLowerCase(), containerClassName)}>
            <div className={classnames("message-panel", severity.toLowerCase(), className)}>
                <div className="message-panel-title">
                    <MetsIcon className="xIcon" name={`svg_${severity.toLowerCase()}`} />
                    {messageTitle}
                </div>
                <div className="message-panel-content">{children}</div>
            </div>
        </div>

    );

}

export default MetsMessages;